import { useEffect, useState } from "react";
import { Tag } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLang } from "../../lib/LangContext";
import { buildWhatsAppLink } from "../../lib/translations";
import { navigateAndScroll } from "../../lib/scroll";
import { splitPath } from "../../lib/i18nRoutes";
import { WA_PATH } from "../../lib/waIcon";
import { useNearSections } from "../../lib/useNearSections";

// Compact bottom-right pill on mobile; hidden while the booking form or footer is on screen.
export const MobileStickyBar = () => {
  const { t } = useLang();
  const location = useLocation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const near = useNearSections();

  const page = splitPath(location.pathname);
  const allowed = Boolean(page.urlLang) && (page.rest === "/" || page.rest === "/academy");

  useEffect(() => {
    if (!allowed) return undefined;
    const onScroll = () => setScrolled(window.scrollY > 220);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [allowed]);

  if (!allowed) return null;
  const visible = scrolled && !near;

  return (
    <div
      data-testid="mobile-sticky-bar"
      aria-hidden={!visible}
      className={`md:hidden fixed right-3 z-40 transition-[opacity,transform] duration-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
      style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)" }}
    >
      <div className="flex items-center gap-1 bg-black/85 backdrop-blur-xl border border-white/15 rounded-full p-1">
        <button
          data-testid="mobile-sticky-price"
          tabIndex={visible ? 0 : -1}
          onClick={() => navigateAndScroll(navigate, "contact", { flow: "price" })}
          className="inline-flex items-center gap-1.5 h-11 bg-gold text-black rounded-full px-4 text-[11px] tracking-[0.14em] uppercase font-semibold whitespace-nowrap"
        >
          <Tag size={13} /> {t.cta.getPriceShort}
        </button>
        <a
          data-testid="mobile-sticky-whatsapp"
          href={buildWhatsAppLink("Hi PUREGLOSS! ")}
          target="_blank"
          rel="noreferrer"
          tabIndex={visible ? 0 : -1}
          aria-label="WhatsApp"
          className="inline-flex items-center justify-center w-11 h-11 rounded-full text-[#25D366]"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden><path d={WA_PATH} /></svg>
        </a>
      </div>
    </div>
  );
};
